import { AccountModule } from '@/core/modules/account/account.module'
import { UserModule } from '@core/modules/user/user.module'
import { ASM_DIALOGS_MAP, DialogService } from '@core/services/dialog'
import { TTheme, useCustomTheme } from '@/core/theme'
import { LinkButton } from '@components/buttons/link'
import { Switch } from '@components/buttons/switch'
import ContentItem from '@components/page-content/content-item'
import Typography from '@/ui/components/typography'
import { Card } from '@routes/settings/routes/user/settings.user.route.styles'
import { CardTitle, ResetMfaWrapper } from './MultiFactorAuth.styles'

const MultiFactorAuth = () => {
    const { currentUser, loading } = UserModule.useStore()
    const theme = useCustomTheme() as TTheme

    async function handleMFAToggle(e: TToggleInput) {
        const { checked } = e.target
        if (checked) {
            await UserModule.toggleMFA(e.target.checked)
        } else {
            await DialogService.showDialog(ASM_DIALOGS_MAP.DISABLE_MFA)
        }
    }

    return (
        <Card>
            <CardTitle>
                <Typography
                    component="p"
                    variant="m-regular"
                    color={theme.colors.greys[800]}
                >
                    Multi-factor authentication (MFA) settings
                </Typography>
            </CardTitle>

            <ContentItem label="Enable MFA">
                <Switch
                    disabled={
                        AccountModule.isMfaEnforced && currentUser?.mfa_active
                    }
                    checked={currentUser?.mfa_active || false}
                    onChange={handleMFAToggle}
                    text={{ on: 'Yes', off: 'No' }}
                    loading={loading}
                    name="mfa-active"
                    testId="toggle"
                />
            </ContentItem>

            <ResetMfaWrapper>
                <LinkButton
                    text="Reset MFA"
                    withChevron={false}
                    color={theme.colors.semantic.error}
                    onClick={() =>
                        DialogService.showDialog(ASM_DIALOGS_MAP.RESET_MFA)
                    }
                />
            </ResetMfaWrapper>
        </Card>
    )
}

export default MultiFactorAuth
